import { Observable } from '../utilities/Observable';

export class UserWallet {
  constructor(data) {
    if (UserWallet.instance) {
      return UserWallet.instance;
    }

    this._data = new Observable(data);
    UserWallet.instance = this;
  }

  get balance() {
    return this._data.value.balance;
  }

  get points() {
    return this._data.value.points;
  }

  get bonus_part() {
    return this._data.value.bonus_part;
  }

  get bonus_balance() {
    return this._data.value.bonus_balance;
  }

  get real_part() {
    return this._data.value.real_part;
  }

  get currency() {
    return this._data.value.currency;
  }

  get data() {
    return this._data.value;
  }

  set data(newData) {
    this._data.value = newData;
  }

  addObserver(callback) {
    this._data.addObserver(callback);
  }

  removeObserver(callback) {
    this._data.removeObserver(callback);
  }
}
